import type { HTMLAttributes } from 'react'
import Button from 'components/Button'
import { TrashIcon } from 'icons'
import copy from 'copy.json'

export default function DeleteButton({
  children = copy.common.button.delete,
  ...props
}: HTMLAttributes<HTMLButtonElement>) {
  return (
    <Button small secondary warning {...props}>
      <TrashIcon />
      {children}
    </Button>
  )
}
